export default __webpack_public_path__ + "static/media/background1.fe19a9f5.jpg";